import { defineMessages } from 'react-intl';

export const scope = 'app';

export default defineMessages({
  chooseFile: {
    defaultMessage: 'Choose File',
    id: `${scope}.chooseFile`,
  },
  emptyState: {
    defaultMessage: 'No file selected',
    id: `${scope}.emptyState`,
  },
});
